import request from '@/utils/request.js'
// 获取学习课程
export const getUserLessonList = data => {
  return request({
    method: 'POST',
    url: '/api/yalimedia.user/record',
    data
  })
}
